<div *ngIf="dataLoaded">
    <aumico-table
        [options]="options"
        [data]="data"
        [delegate]="this"
        [filterSubject]="onFilterEvent"
        detachPager="true"
    >
    </aumico-table>
</div>
